import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function packages() {
    return {
        index,
        get,
        sendEmail,
        save,
        update,
        addImage,
        removeImage,
        printPdf,
        printLabel,
        close,
        reopen,
        remove,
        reports,
        templates,
        checkTracking,
        sendNotification,
        status,
        deleteStatus,
        getBodyEmail,
        exportReceiptFile,
        printCustomLabel
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`receipt/search${params}`);
    }

    function get(packageId) {
        return axiosInstance.get(`receipt/get?id=${packageId}`);
    }

    function sendEmail({ id, emails, body, subject }) {
        return axiosInstance.post(`receipt/send-emails`, {
            id: id,
            emails: emails,
            body: body,
            subject: subject
        });
    }

    function save(payload) {
        if (payload.id) {
            return axiosInstance.patch('receipt/update', payload);
        } else {
            const formData = new FormData();

            formData.append('shipper', payload.shipper);
            formData.append('receiver', payload.receiver);
            formData.append('agent', payload.agent);
            formData.append('agency', payload.agency);
            formData.append('location', payload.location);
            formData.append('arriveDate', payload.arriveDate);
            formData.append('carrier', payload.carrier?.id);
            formData.append('packType', payload.packType);
            formData.append('description', payload.description);
            formData.append('tracking', payload.tracking);
            formData.append('value', payload.value);
            formData.append('length', payload.length);
            formData.append('width', payload.width);
            formData.append('height', payload.height);
            formData.append('weight', payload.weight);
            formData.append('numberPack', payload.numberPack);
            formData.append('shippingType', payload.shippingType);
            formData.append('note', payload.note);

            payload.files.forEach((file) => {
                formData.append('files', file);
            });

            return axiosInstance.post('receipt/create', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }

    function update(payload) {
        return axiosInstance.patch('receipt/update', payload);
    }

    function addImage(image, id, comment = '') {
        const formData = new FormData();
        formData.append('file', image);
        formData.append('comment', comment);
        formData.append('id', id);

        return axiosInstance.post('receipt/add-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeImage(imageId, packageId) {
        return axiosInstance.delete(`receipt/delete-image`, {
            data: {
                receiptId: packageId,
                imageId: imageId
            }
        });
    }

    function printPdf(Ids) {
        return axiosInstance.post(
            'package/receipt_pdf',
            { ids: Ids },
            {
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    function printLabel(id) {
        return axiosInstance.get(`receipt/label?id=${id}`, {
            timeout: 60000,
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }

    function close(options) {
        const formData = new FormData();
        formData.append('id', options.id);
        formData.append('comment', options['comment']);
        formData.append('sendNotification', options['sendNotification']);

        if (options['signature']) {
            formData.append(
                'signature',
                options['signature'],
                `signature_${options.id}.png`
            );
        }

        if (options['images']) {
            options.images.forEach((image) => {
                console.log('image', image);
                formData.append('images[]', image.file);
            });
        }

        return axiosInstance.post('receipt/delivered', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function reopen({ id, comment }) {
        return axiosInstance.post(`receipt/reopen`, {
            id,
            comment
        });
    }

    function deleteStatus(statusId) {
        return axiosInstance.delete(`receipt/delete-status`, {
            data: statusId
        });
    }

    function remove(packageId) {
        return axiosInstance.delete(`receipt/delete`, {
            data: {
                id: packageId
            }
        });
    }

    function templates() {
        return axiosInstance.get(`packagetemplate/search`);
    }

    function checkTracking(tracking) {
        return axiosInstance.get(`package/checktracking?tracking=${tracking}`);
    }

    function reports(params) {
        const fileName = `ReportPackages.xlsx`;
        let urlParams = 'fini=' + params.fini;
        urlParams += '&fend=' + params.fend;
        let headers = null;
        switch (params.type) {
            case 'excel':
                headers = {
                    'Content-Disposition': `attachment; filename=${fileName}`,
                    'Content-Type':
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                };
                urlParams += '&reportType=excel';
                break;
            case 'pdf':
                headers = {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                };
                urlParams += '&reportType=pdf';
                break;
        }
        if (params.agencyid) {
            urlParams += '&agencyid=' + params.agencyid;
        }
        if (params.shippingtype) {
            urlParams += '&shippingtype=' + params.shippingtype;
        }
        if (params.locationid) {
            urlParams += '&locationid=' + params.locationid;
        }
        if (params.agentid) {
            urlParams += '&agentid=' + params.agentid;
        }
        if (params.pStatus) {
            urlParams += '&pStatus=' + params.pStatus;
        }
        return axiosInstance.get(`package/reports?${urlParams}`, {
            timeout: 60000,
            responseType: 'arraybuffer',
            headers
        });
    }

    function sendNotification(payload) {
        return axiosInstance.post('/receipt/send-notifications', payload);
    }

    function status(payload) {
        return axiosInstance.post('receipt/create-status', payload);
    }

    function exportReceiptFile(options = {}, type = 'pdf') {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            format: type
        };
        let params = {};
        let headers = {};

        if (type === 'pdf') {
            const args = options ? JSON.parse(options) : null;
            params = generateQueryParams(args.query, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            };
        } else {
            params = generateQueryParams(options, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer'
            };
        }
        return axiosInstance.get(`receipt/export${params}`, headers);
    }

    function getBodyEmail(id) {
        return axiosInstance.get(`receipt/get-body-email?id=${id}`);
    }

    function printCustomLabel(id, formatId) {
        return axiosInstance.get(
            `receipt/label-custom?id=${id}&labelFormatId=${formatId}`,
            {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            }
        );
    }
}
